import React from 'react';
import logo from '../../assets/logo.png';

const AuthLayout = ({
    children,
    title,
    subtitle,
    testimonialQuote,
    testimonialAuthor,
    testimonialImage,
    testimonialLink
}) => {
    return (
        <div className="relative min-h-screen bg-accent/30 lg:bg-white flex">
            {/* Logo */}
            <div className="absolute top-6 left-6">
                <img
                    src={logo}
                    alt="Klasite"
                    className="h-8"
                />
            </div>
            {/* Left Column - Auth Form */}
            <div className="lg:w-1/2 mx-auto flex flex-col lg:bg-white p-8">
                <div className="flex-grow flex items-center justify-center">
                    <div className="w-full max-w-md space-y-6">
                        <div>
                            <h2 className="text-3xl font-bold text-gray-900">
                                {title}
                            </h2>
                            <p className="mt-2 text-sm text-gray-600">
                                {subtitle}
                            </p>
                        </div>

                        {children}
                    </div>
                </div>
            </div>

            {/* Right Column - Quote */}
            <div className="hidden w-1/2 bg-gray-50 lg:flex items-center justify-center p-16">
                <div className="max-w-md relative">
                    {/* Large decorative quote mark */}
                    <svg
                        className="absolute -top-14 -left-8 h-16 w-16 text-[#658db8]"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
                    </svg>

                    <blockquote className="text-3xl font-medium text-gray-900 relative">
                        {testimonialQuote}
                    </blockquote>
                    <div className="mt-6 flex items-center">
                        <a
                            href={testimonialLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center hover:opacity-90 transition-opacity"
                        >
                            <img
                                src={testimonialImage}
                                alt="User avatar"
                                className="h-10 w-10 rounded-full object-cover shadow-sm"
                            />
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">{testimonialAuthor}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;